export function DiagramProjectRegular({ width = 16 }: { width?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
      width={width}
      fill="none"
    >
      <path
        d="M112 144L112 240L208 240L208 144L112 144zM64 144C64 117.5 85.5 96 112 96L208 96C234.5 96 256 117.5 256 144L256 168L384 168L384 144C384 117.5 405.5 96 432 96L528 96C554.5 96 576 117.5 576 144L576 240C576 266.5 554.5 288 528 288L432 288C405.5 288 384 266.5 384 240L384 216L256 216L256 240C256 250.4 252.7 260.1 247 268L310 352L400 352C426.5 352 448 373.5 448 400L448 496C448 522.5 426.5 544 400 544L304 544C277.5 544 256 522.5 256 496L256 400C256 389.6 259.3 379.9 265 372L202 288L112 288C85.5 288 64 266.5 64 240L64 144zM304 400L304 496L400 496L400 400L304 400zM528 144L432 144L432 240L528 240L528 144z"
        fill="currentColor"
      />
    </svg>
  );
}
